// Action Types

export const SET_ACTIVE_MODAL = 'SET_ACTIVE_MODAL'

// Action Creators

export function openModalWithContainer(container, props = {}) {
  return {
    type: SET_ACTIVE_MODAL,
    active: container,
    props: props,
  }
}

export function closeModal() {
  return {
    type: SET_ACTIVE_MODAL,
    active: null,
  }
}

// Initial State

const initialState = {
  active: null,
}

// Reducer

export default function reducer(state = initialState, action) {
  const nextState = Object.assign({}, state)

  switch (action.type) {
    case SET_ACTIVE_MODAL:
      nextState.active = action.active
      nextState.props = action.props
      return nextState
    default:
      return state
  }
}
